import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11ca4b59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cropper-content" }
const _hoisted_2 = { class: "cropper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-preview" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "preview previewBefore" })
], -1))
const _hoisted_5 = { class: "cropper-fn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ant_icon = _resolveComponent("ant-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: true,
    centered: true,
    keyboard: false,
    "mask-closable": false,
    onOk: _ctx.handleOk,
    onCancel: _ctx.cancel,
    title: "修改图片",
    okText: "点击上传",
    width: "900px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            ref: "imageRef",
            src: _ctx.image,
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cropperZoom(0.05)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ant_icon, { type: "ZoomInOutlined" })
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cropperZoom(-0.05)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ant_icon, { type: "ZoomOutOutlined" })
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cropperRotate(-90)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ant_icon, { type: "UndoOutlined" })
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cropperRotate(90)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ant_icon, { type: "RedoOutlined" })
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, { onClick: _ctx.sureSava }, {
          default: _withCtx(() => [
            _createVNode(_component_ant_icon, { type: "VerticalAlignBottomOutlined" })
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onOk", "onCancel"]))
}